import { useQueryClient } from '@tanstack/react-query';
import { useEventStream } from '../hooks/useEventStream.js';
import { notifStore } from '../stores/notifications.js';

export function GlobalEventListener() {
  const qc = useQueryClient();

  useEventStream({
    topics: ['ehr:catalog', 'build:catalog', 'session:all'],
    onEvent: (msg: MessageEvent) => {
      try {
        const event = JSON.parse(msg.data as string) as {
          type: string;
          payload: Record<string, unknown>;
          topic: string;
        };

        if (event.type === 'conflict') {
          const p = event.payload as { sessionId: string; kind: string; severity: string };
          notifStore.push({
            severity: p.severity === 'error' ? 'error' : 'warn',
            title: `New conflict: ${p.kind}`,
            body: `Session ${String(p.sessionId).slice(0, 8)} needs attention`,
            href: '/conflicts',
          });
          void qc.invalidateQueries({ queryKey: ['conflicts'] });
          void qc.invalidateQueries({ queryKey: ['stats'] });
        }

        if (event.type === 'stage.finished') {
          const p = event.payload as {
            stage: string;
            status: string;
            sessionId: string;
            durationMs: number;
          };
          void qc.invalidateQueries({ queryKey: ['sessions'] });
          if (p.status === 'error') {
            notifStore.push({
              severity: 'error',
              title: `Stage failed: ${p.stage}`,
              body: `Session ${String(p.sessionId).slice(0, 8)} — ${p.stage} stage errored`,
              href: `/sessions/${p.sessionId}`,
            });
          } else if (p.status === 'done' && p.stage === 'export') {
            notifStore.push({
              severity: 'success',
              title: 'Export complete',
              body: `Session ${String(p.sessionId).slice(0, 8)} finished export in ${(p.durationMs / 1000).toFixed(1)}s`,
              href: `/sessions/${p.sessionId}`,
            });
          }
        }

        if (event.type === 'stage.started') {
          void qc.invalidateQueries({ queryKey: ['sessions'] });
        }

        if (event.type === 'recipe.updated') {
          const p = event.payload as { ehrSlug: string; version: string };
          notifStore.push({
            severity: 'info',
            title: `Recipe updated: ${p.ehrSlug}`,
            body: `New version ${p.version} is ready`,
            href: '/ehrs',
          });
        }
      } catch {
        // malformed event — ignore
      }
    },
  });

  return null;
}
